import theme from '@styles/theme';

/** Style CTA – kolory z headerColor, hover z kontrastującym tekstem */
const ctaButton = (color: string) => {
  const hoverText = theme.rawColors.neutralWhite;
  return {
    borderColor: color,
    color,
    '& span': {
      color
    },
    // GlobalStyles ustawia a:visited → trzeba utrzymać kolor buttona
    '&:visited': {
      color,
      borderColor: color,
      '& span': {
        color
      }
    },
    '&:hover, &:hover:visited': {
      backgroundColor: color,
      borderColor: color,
      color: hoverText,
      '& span': {
        color: hoverText
      }
    }
  };
};
export default {
  visualBlockSection: {
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    height: ['138.6666667vw', '138.6666667vw', '133.333333vw', '133.333333vw', '46.875vw']
  },
  blockContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'end',
    p: ['17.0666667vw 10.6666667vw', '17.0666667vw 10.6666667vw', '10.4166667vw 8.33333333vw', '10.4166667vw 8.33333333vw', '6.04166667vw 10.15625vw'],
    'h2.display__three.mobile': {
      lineHeight: '110%'
    },
    'h2.headings.heading__one': {
      fontSize: [60, 60, 80, 80, 112, 148],
      span: {
        wordSpacing: 'unset',
        display: ['block', 'block', 'block', 'block', 'table-caption']
      }
    }
  },
  ctaButton
};